<template>
  <div>
    <div class="item-container" :class="{ 'error-border': item.invalid_file }">
      <span class="close" @click.prevent="removeFile">X</span>
      <span
        v-if="item.uploaded == false && item.invalid_file == false"
        class="percentage"
        :class="{
          'loading-send': item.uploaded == false && item.invalid_file == false
        }"
        >{{ item.progressing }}</span
      >
      <div
        class="loding-spin"
        :class="{
          'loading-send': item.progressing != 100 && item.invalid_file == false
        }"
        v-if="item.progressing != 100 && item.invalid_file == false"
      ></div>
      <img :src="image" alt v-if="image" />
      <a href="#" v-else>
        <a-icon type="file" :style="{ fontSize: '16px', color: '#08c' }" />
      </a>
    </div>
    <a
      href="#"
      style="font-size: 9px;"
      v-if="item.progressing == 100"
      @click.prevent="onDownload"
      >{{ $t('homework.download') }}</a
    >
  </div>
</template>

<script>
export default {
  name: 'fileItem',
  props: {
    item: {
      type: Object
    },
    fileIndex: {
      type: Number
    }
  },
  data() {
    return {
      image: ''
    }
  },
  created() {
    this.readAsUrl()
  },
  methods: {
    readAsUrl() {
      if (['image/png', 'image/jpeg'].includes(this.item.type)) {
        if (this.item.uploaded && this.item.size == 0) {
          this.image = this.item.storage_path
          return
        }
        const reader = new FileReader()
        reader.onload = e => {
          this.image = e.target.result
        }
        reader.readAsDataURL(this.item.file)
      }
    },
    removeFile() {
      this.$emit('remove', { index: this.fileIndex, record: this.item })
    },
    onDownload() {
      this.$emit('download', { index: this.fileIndex, record: this.item })
    }
  },
  watch: {
    item: {
      handler() {
        this.readAsUrl()
      },
      deep: true
    }
  }
}
</script>

<style scoped>
img {
  width: 40px;
  height: 40px;
  border-radius: 8px;
  padding: 3px;
  object-fit: cover;
  object-position: center;
  background: #fff7f7;
}
.item-container {
  position: relative;
  border: 1px solid #e8e5e5;
  margin-right: 7px;
  border-radius: 8px;
  width: 41px;
  height: 41px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.item-container:hover .close {
  visibility: visible;
}
.close {
  visibility: hidden;
  position: absolute;
  background: rgb(128, 128, 128);
  color: rgb(19, 19, 19);
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 14px;
  top: 7px;
  left: -8px;
  height: 26px;
  width: 26px;
  border-radius: 16px;
  opacity: 43%;
}
.percentage {
  visibility: hidden;
  position: absolute;
  background: rgb(128, 128, 128);
  color: rgb(19, 19, 19);
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 10px;
  top: 7px;
  left: 8px;
  height: 26px;
  width: 26px;
  border-radius: 16px;
  opacity: 80%;
}
.loding-spin {
  visibility: hidden;
  height: 26px;
  width: 26px;
  border-radius: 50%;
  border: 2px solid rgba(29, 161, 242, 0.2);
  border-left-color: rgb(29, 161, 242);
  background: transparent;
  animation: rotate-s-loader 1s linear infinite;
  top: 7px;
  left: 7px;
  position: absolute;
}

@keyframes rotate-s-loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
.error-border {
  border: 1px solid red !important;
}
.loading-send {
  visibility: visible !important;
}
</style>
